import React from 'react';

export const ErrorDialog = ({ dialog: { message, buttonText, callback } }) => (
  <div
    className='dialog-md dialog--modal'
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <div className='dialog-md__body text-center'>{message}</div>
    <div className='dialog-md__footer-horizontal'>
      <button
        id='modal-close-copy'
        className='btn--sm--sub'
        onClick={callback.close}
      >
        {buttonText || '戻る'}
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/dialogs/ErrorDialog.jsx